(function() {
    var isMobile = window.innerWidth < 768;

    function funcReady() {
        ;(function(){
            var $component;
            var $mainSticky;

            var $onText;
            var $moreInfos;

            var selectIdx;
            var prevIdx;

            var $pdpWrap;
            var $header;

            function init(){
                setting();
                bindEvents();
                $(window).off('load.KRC0040-2').on('load.KRC0040-2', scrollEvent);
                $(window).off('scroll.KRC0040-2').on('scroll.KRC0040-2', scrollEvent);
                
                $(window).off('breakpointchange.KRC0040-2').on('breakpointchange.KRC0040-2', breakpointChange);
                $component.off('refresh.KRC0040-2').on('refresh.KRC0040-2', refresh);
            }

            function setting(){
                $component = $('.KRC0040');
                $onText = $component.find('.on-txt');
                $moreInfos = $component.find('.more-infos');

                $mainSticky = $('.KRP0009');

                selectIdx = prevIdx = 0;

                $component.parent().height($component.innerHeight());

                $pdpWrap = $('.subRenewPdpWrap');
                $singleTabWrap = $('.subRenewWrap');
                $header = $pdpWrap.find('header.header');

                var navH = $singleTabWrap.find('.mobile-nav-wrap').height();
                var fixedMH = $onText.height();
                var mobileTop = navH + fixedMH;
                var pcTop = $component.height();
                if( !$('.iw_viewport-wrapper').hasClass('subRenewPdpWrap') ){
                    $('.KRC0004').closest('.component-wrap').css('margin-top', isMobile ? mobileTop+'px' : pcTop);
                }
            }

            function refresh() {
                scrollEvent();
            }

            function breakpointChange(e, data) {
                isMobile = data.isMobile;
            }

            var lastOffestY = window.scrollY;

            function scrollEvent(e){
                $component.show();
                var scrolltop = $(window).scrollTop();
                var topDistance = 0;
                var comptop = $component.parent().offset().top;
                var dist = -scrolltop + comptop;
                var navH = isMobile ? $singleTabWrap.find('.mobile-nav-wrap').height() : 0;
                $singleTabWrap.find('.header').removeClass('hide')
                $singleTabWrap.find('.mobile-nav-wrap').removeClass('hide')

                if (!!$mainSticky.length && !isNaN(parseInt($mainSticky.attr('data-bottom')))) {
                    topDistance += parseInt($mainSticky.attr('data-bottom'));
                } else {
                    // KRP0009 없어 'data-bottom' 참조 못할 때 대비
                    if (isMobile && !$pdpWrap.hasClass('gnb-fixed') && window.scrollY <= lastOffestY ) {
                        topDistance += $header.height();
                    }
                }

                if(dist <= topDistance){
                    var navH = $('.mobile-nav-wrap').height() +'px';

                    $component.addClass('fixed');
                    
                    if( $('.iw_viewport-wrapper').hasClass('subRenewPdpWrap') ){
                        $component.css({
                            position: 'fixed',
                            top: topDistance,
                            width: '100%',
                            zIndex: 91,
                            paddingTop: 0
                        });
                    } else{
                        $component.css({
                            position: 'fixed',
                            top: navH,
                            width: '100%',
                            zIndex: 91,
                            paddingTop: 0
                        });
                    }
                } else{
                    $component.removeClass('fixed').removeAttr('style');
                }

                lastOffestY = window.scrollY;

                var currentIdx = -1;
                var isAllHidden = true;
                $component.find('.info-tab').each(function(idx, item){
                    // S :  [BTOCSITE-81509] [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0
					// var percent = 0, display;
                    var contID = $(item).find('a').attr('href');

                    var contIDX = contID.indexOf("#iw_comp");
                    if(contIDX > -1){
                        // var bar = $(item).find('a .bar');
                        var cont = $(contID);
                        if(cont.length){
                            var conty = cont.offset().top;
                            var contheight = cont.outerHeight(true);

                            if(!idx) conty -= $component.height();

                            var endanchor = $(item).find('a').data('endTarget');
                            if(endanchor && $(endanchor).length){
                                var endy = $(endanchor).offset().top;
                                var endheight = $(endanchor).outerHeight(true);
                                contheight = endy - conty + endheight;
                            }

                            var contop = -scrolltop + conty;
                            if($mainSticky.length) contop -= $mainSticky.height()-2;
                            // if(contop < topDistance){
                            //     var scrolldist = topDistance - contop;
                            //     percent = scrolldist / contheight * 100;

                            //     if(percent > 100) percent = 0;
                            // }
                            var display = contop > 0 ? 'none' : 'block';
                            // bar.css({width: percent+"%", display: display});

                            if(display == "block") {
                                isAllHidden = false;
                                currentIdx = idx;
                            }
                        }
                    }
                    // E :  [BTOCSITE-81509] [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0
                });

                if(selectIdx != currentIdx){
                    prevIdx = selectIdx;
                    selectIdx = currentIdx;

                    var no = selectIdx;
                    if(selectIdx < 0){
                        no = prevIdx;
                    }

                    $moreInfos.children().removeClass('active');
                    $moreInfos.children().eq(no).addClass('active');
                    $onText.text($moreInfos.children().eq(no).text());
                }
            };

            function bindEvents(){

                $component.on('click', '.info-tab a', function(e){
                    var id = $(this).attr('href');
                    var idx = id.indexOf("#iw_comp");
                    if(idx > -1){
                        e.preventDefault();

                        scrollMoved(id);
                    }
                });

                $onText.on('click', function(e){
                    e.preventDefault();

                    toggleTabList();
                })
            }

            function toggleTabList(){
                if(!$moreInfos.data('isOpen')){
                    $moreInfos.data('isOpen', true);
                    var leng = $moreInfos.children().length;
                    var itemheight = $moreInfos.children().height();
                    $moreInfos.height(itemheight*leng);

                    $moreInfos.closest('.product-info-more').addClass('open');
                } else{
                    $moreInfos.data('isOpen', false);
                    $moreInfos.height(0);

                    $moreInfos.closest('.product-info-more').removeClass('open');
                }
            }

            function scrollMoved(id){
                if($(id).length){
                    var topDistance = 0;
                    if($mainSticky.length) topDistance += $mainSticky.height()-2;
                    var navH = $singleTabWrap.find('.mobile-nav-wrap').height();

                    // [BTOCSITE-81509] [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0
                    // var movtop = $(id).offset().top - topDistance + navH + 1;
                    var movtop = $component.hasClass('fixed') ? $component.position().top + $(id).offset().top - topDistance + navH + 1 : $(id).offset().top - topDistance  + navH + 1;
                    
                    $('html, body').stop().animate({scrollTop:movtop}, 200, function () {
                        if ($(this).is('body')) focusInCont(id); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0
                    });

                    if($moreInfos.data('isOpen')){
                        toggleTabList();
                    }
                }
            }
            
            // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0
            function focusInCont(id) {
                var $cont = $(id);
                
                if (!!$cont.length) {
                    $cont.attr('tabindex', 0).focus();
                    $cont.off('focusout.KRC0040-2').one('focusout.KRC0040-2', function () {
                        $cont.removeAttr('tabindex');
                    });
                }
            }

            init();
        })();

        // Make it easier to find ID values ​​in the teamsite edit screen
        window.Clipboard = (function (window, document, navigator) {
            var textArea,
                copy;

            function isOS() {
                return navigator.userAgent.match(/ipad|iphone/i);
            }

            function createTextArea(text) {
                textArea = document.createElement('textArea');
                textArea.value = text;
                textArea.style.position = 'fixed';
                textArea.style.top = '0';
                textArea.style.left = '0';
                textArea.style.opacity = '0.0001';
                textArea.style.width = '100%';
                textArea.style.height = '100%';
                textArea.style.padding = '0';
                textArea.style.pointerEvents = "none";
                textArea.style.fontSize = '16px';
                document.body.appendChild(textArea);
            }

            function selectText() {
                var range,
                    selection;

                if (isOS()) {
                    range = document.createRange();
                    range.selectNodeContents(textArea);
                    selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                    textArea.setSelectionRange(0, 999999);
                } else {
                    textArea.select();
                }
            }

            function copyToClipboard() {
                document.execCommand('copy');
                document.body.removeChild(textArea);
            }

            copy = function (text) {
                createTextArea(text);
                selectText();
                copyToClipboard();
            };
            return {
                copy: copy
            };
        })(window, document, navigator);

        if($('body').hasClass('iw-fullscreen-edit')) {
            $('.component-wrap').each(function() {
                var obj = $(this).parent();
                if(obj.is('.iw_component')) {
                    var iwid = obj.attr('id');
                    if(iwid) {
                        obj.find('.component-wrap').append('<a href="#" class="btn copy-myid" style="position:absolute;left:0;top:0;background:#d9ffde;opacity:0.5;text-transform:none;color:#000;z-index:1000;">'+iwid+'</a>');
                    }
                }
            });
            $('body').on('click', 'a.copy-myid', function(e) {
                e.preventDefault();
                var iwid = $(this).text();
                Clipboard.copy(iwid);
                $(this).append('<div id="copyedText" style="font-size:13px;">Copied!</div>');
                setTimeout(function() {
                    $('#copyedText').remove();
                }, 1500);
            });
        };
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRC0040-2.0.0', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRC0040')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRC0040')) return false;
        funcReady();
    });
    //[BTOCSITE-38396]그램찾기 iframe 제품정보 탭 오류 수정 
    var $specSticky;
    var contentHArr = []
    function setChildSpec(){
        window.parent.postMessage( ['KRC0040_html', $('.component.KRC0040').parent().html()], '*');
        $specSticky = $('.component.KRC0040');
        $specSticky.parent().hide()
        $(window).on('resizeend',function(){
            contentHArr[0] = 0;
            for(var i = 1; i<=$('.product-info-more .info-tab').length; i++){
                //var href = $('.product-info-more .info-tab').eq(i-1).find('a').attr('href');
                var endId = $('.product-info-more .info-tab').eq(i-1).find('a').attr('data-end-target');
                //var prevH = contentHArr[i-1];

                if ($(endId).length > 0) contentHArr[i] = $(endId).offset().top +$(endId).outerHeight(true);

                //console.log('prevH '+prevH);
                console.log('content scrollTop '+ contentHArr[i]);
            }
            window.parent.postMessage( ['gramHeight', $(document).height() ], '*');
        }).trigger('resizeend');
        $('.product-info-more .info-tab a').on('click',function(e){
            var id = $(this).attr('href');
            var top = $(id).offset().top;
            window.parent.postMessage( ['gramClick', top, $('.product-info-more .info-tab').eq(0).height()], '*');
            $('.product-info-more .info-tab').removeClass('active')
            $(this).parent().addClass('active')
        });
    }
    window.addEventListener('message', function(e) {
        if(e.data[0] == 'specSticky'){
            var scrollTop = e.data[1];
            var scrollIdx=0;
            for(var i=0; i<contentHArr.length; i++){
                if(contentHArr[i] <= scrollTop+4){
                    scrollIdx = i;
                }
            }
            window.parent.postMessage( ['active', scrollIdx ], '*');
        }else if(e.data[0] == 'click'){
            window.parent.postMessage( ['scrollMove', $(e.data[2]).offset().top ], '*');
        }else if(e.data[0] == 'setChildSpec'){
            //init
            setChildSpec();
        }
    });
    ////[BTOCSITE-38396]그램찾기 iframe 제품정보 탭 오류 수정 
})();